import type { ReactElement } from 'react';
import { useGamesSite } from '../context';
import { gameCount } from '../format';
import { genreGradient, genreLook } from '../genres';
import { gamesGenrePath } from '../routes';
import type { GameGenreSummary } from '../types';

/** Every genre with games, as a coloured tile that opens it. */
export function GenreGrid({
  genres,
  title = 'Browse by genre',
}: {
  genres: GameGenreSummary[];
  title?: string;
}): ReactElement | null {
  const { Link } = useGamesSite();
  const shown = genres.filter((g) => g.count > 0);
  if (shown.length === 0) return null;
  return (
    <section className="fg-shelf" aria-labelledby="fg-genres">
      <div className="fg-shelf__head">
        <h2 id="fg-genres" className="fg-h2">
          {title}
        </h2>
      </div>
      <ul className="fg-genres">
        {shown.map((genre) => (
          <li key={genre.id}>
            <Link
              href={gamesGenrePath(genre.id)}
              className="fg-genre"
              aria-label={`${genre.label}, ${gameCount(genre.count)}`}
            >
              <span
                className="fg-genre__fill"
                style={{ backgroundImage: genreGradient(genre.id) }}
                aria-hidden="true"
              />
              <span className="fg-genre__glyph" aria-hidden="true">
                {genreLook(genre.id).glyph}
              </span>
              <span className="fg-genre__label" aria-hidden="true">
                {genre.label}
              </span>
              <span className="fg-genre__count" aria-hidden="true">
                {gameCount(genre.count)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
